import {Columns} from 'compob2b-table';
import {translations} from '../../../../environments/translations.ru';


export const DAM_RELATED_COLLECTION_FORM: Columns[] = [
  {
    key: 'header',
    title: translations.header,
    placeholder: translations.header,
    searchEnabled: true,
    formly: true,
    grid: true,
    type: 'input',
    required: true,
    width: '90%',
  },
  {
    key: 'damRelatedClassId',
    title: translations.damRelatedClass,
    placeholder: translations.damRelatedClass,
    formly: true,
    type: 'select',
    grid: false,
    required: true,
    templateOptions: {
      label: translations.damRelatedClass,
      required: true,
      type: 'array',
      valueProp: 'id',
      labelProp: 'header'
    },
  },
  {
    key: 'damRelatedClass',
    title: translations.damRelatedClass,
    placeholder: translations.damRelatedClass,
    formly: false,
    type: 'select',
    grid: false,
    searchEnabled: false,
    required: true,
    templateOptions: {
      label: translations.damRelatedClass,
      required: true,
      type: 'array',
      valueProp: 'id',
      labelProp: 'header'
    },
  },
  {
    key: 'pos',
    title: translations.position,
    placeholder: translations.position,
    searchEnabled: true,
    formly: true,
    grid: false,
    type: 'input',
    required: false,
    defaultValue: 0,
    templateOptions: {
      label: translations.position,
      type: 'number',
      step: 1,
      required: true,
      min: 0,
      max: 1000000000,
    },
  },
  {
    key: 'enabled',
    title: translations.enabled,
    placeholder: translations.enabled,
    searchEnabled: false,
    formly: true,
    grid: false,
    defaultValue: true,
    type: 'checkbox',
    required: true
  },
  {
    key: 'action',
    title: translations.action,
    placeholder: translations.action,
    searchEnabled: false,
    grid: true,
    formly: false,
    type: 'input',
    required: true
  }
];
